<template>
<div class="ui grid" >
  

    <section class="row intro">
         <div class="column">
          <div>
            <div class="ui secondary green pointing compact menu">
      
  <div class="menu">
  <a class="active item" href="#why">
    Why Restock
  </a>
  <a class="item" href="#features">
    Features
  </a>
  <a class="item" href="#works">
    How It Works
  </a>
      
  </div>
</div>
</div>
      <div class="logo">
      <div><i class="unhide green large icon"></i></div>
         <div>Restock</div>
      <!--<i class="registered icon"></i> -->
      </div> 
      
      <div style="margin-bottom: 2em;">
    <h2 id="type">INVENTORY MANAGEMENT ON AUTOPILOT</h2>
          <h4>Restock is a dedicated subscription based marketplace for office supplies.</h4>
       
          <button class="ui green button" :class="{medium: $isMobile, medium: !$isMobile}" @click="$router.push('signup')">CREATE FEE ACCOUNT</button>
          <button class="ui orange  button" :class="{medium: $isMobile, medium: !$isMobile}" @click="$router.push('login')">LOG IN</button>
          </div>
<transition name="scale" appear>


<img :src="$imgUrl('banner.png')" align="center">
<!--
<img :src="$imgUrl('laptop.png')" align="center"> 
<img src="https://tray.io/images/video/browser-filled-responsive.jpg" align="center">
-->
</transition>
      </div>
      

    </section>



<!--
<section class="ui segment centered row reference">
<div class="column centertext">
  <div class="">Trusted by:</div>
<div>
<img src="https://trace.risingstack.com/images/customer-sanoma.png" >
  <img src="https://trace.risingstack.com/images/customer-cisco.png" >
  <img src="https://trace.risingstack.com/images/customer-emarsys.png" >
<img src="https://trace.risingstack.com/images/customer-university-of-limerick.png" >

  <div>
  </div>
</section>
-->

    <section class="row common why" id="why">
            <div class="column">
      
      <h2 class="centertext spacing">Why Restock ?</h2>

    <ul>
      How many times have you run out of paper or ink cartridges or something as basic as a felt-tip marker? 
      Wouldn't it be nice if the next time you needed to order office supplies, they were already there?
      That's the idea behind Restock subscription service. Sign up to receive regular shipments at a designated frequency and you won't have to worry about reordering.
      </ul>
      
            </div>
    </section>

    <section class="row common features" id="features">
      <div class="column">
      <h2 class="ui green header centertext spacing">Features</h2>
      <ul>
        <li class="">Subscribe products, suspend or cancel subscriptions.</li>
        <li class="">Requisitions and invoice management.</li>
        <li class="">Auto Order placement on minimum stock level.</li>
        <li class="">One Invoice for all monthly supplies.</li>
        <li class="">Transparent Retail and Wholesale pricing.</li>
        <li class="">Best customer service.</li>
      </ul>
      </div>
    </section>

    <section class="row common works" id="works">
      <div class="column">
      <h2 class="centertext spacing">How It Works</h2>
      <div class="divider"></div>
      <ol class="horizontal layout wrap">
        <li>Create your free account.</li>
        <li>Subscribe products you reqularly use.</li>
        <li>Define Min & restock level for your subscriptions.</li>
        <li>Manage staff requisitions.</li>
        <li>Receive regular shipments.</li>
        <li>Pay monthly invoice.</li>
           </ol>
      </div>
    </section>


<section class="centred row try common" style="padding-top: 2em !important;">
<div class="column centertext">
<h2 style="color: red !important; font-weight:100;">Never Run Out Of Office Supplies Again!</h2>
<h3 style="margin-top:0; font-weight:100; font-style: italic;">Find Everthing Your Office Needs</h3>
<button class="ui green medium button" @click="$router.push('signup')">GET STARTED FOR FREE</button>

</div>
</section>

    <section class="row footer">
     <div class="column">
       <i class="cube large icon"></i><span>An Officeware Company</span><span v-if="!$isMobile"> - All rights reserved</span>
      </div>
    </section>
  </div>

</template>

<script>
  'use strict';
  import Script2 from '../../plugins/script2'
export default {
  name:'home',
  data () {

    return {
      //msg: 'Hello Restock'
    }
  },
  created() {
    if(!this.$isMobile) {
    Script2.load('https://safi.me.uk/typewriterjs/js/typewriter.js')
    .then(() => {
  var typewriter = new Typewriter(document.getElementById('type'), {
  //  strings: ['INVENTORY MANAGEMENT ON AUTOPILOT','Never Run Out Of Office Supplies Again!', 'Find Everthing Your Office Needs'],
 //   autoStart: true,
    loop: true,
    typingSpeed: 30,
   deleteSpeed: 25
});

typewriter.typeString('INVENTORY MANAGEMENT ON AUTOPILOT')
    .pauseFor(2500)
    .deleteAll()
    .typeString('NEVER RUN OUT OF OFFICE SUPPLIES AGAIN!')
    .pauseFor(2500)
    .deleteAll()
    .typeString('FIND EVERYTHING YOUR OFFICE NEEDS')
    .pauseFor(2500)
    .deleteAll()
    .start();

    })
     .catch((err) => {})
    }
     },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid {margin:0 !important;}

.menu {border: none !important;}
  .intro {
  margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    text-align: center;
    line-height: 1.8em;
    word-spacing: 0.035em;
    background: #fff;
/*background: url(http://7days.ae/wp-content/uploads/2015/05/iStock_education_Medium.jpg);
    background-size: cover;
    background-repeat: no-repeat;
*/
  }
.intro .logo {
    font-size: 3em !important;
  margin: 1em 0 .8em;
      display: flex;
      flex-direction: column;
    justify-content: center;
    align-items: center;
}

.intro img {
  width: 63% !important;
  
  }

.intro  h2 {
    font-weight: 500;
    line-height: 1.3em;
    word-spacing: .3em;
    letter-spacing: .05em;
    margin-bottom: .2em !important;
      }


  h4 {
    letter-spacing: .05em;
    margin-top:0;
    font-size: 1.2em;
    font-weight: 300;
    line-height: 1.6em;
    word-spacing: .3em;
    margin-bottom: 1.5em;
  }
  p {
    color: rgba(255,255,255,0.8);
  } 
  
  .spacing {
     letter-spacing:.1em !important; letter-spacing:.2em;
  }

.why {
  /*background: #77ab8b !important;*/
  background: rgba(89, 175, 78, 0.72) !important;
  padding-top: 5em !important;
}

  .why ul {
    width: 60%;
    word-spacing: .1em;
    letter-spacing: .02em;
    text-align: justify;
    padding-left: 0;
  }
  .why h2, .why ul, .works h2, .works ol {
    color: #fff !important;
  }

.works {background: rgba(89, 175, 78, 0.72) !important;}

.try {
 background: url(/static/footer.jpg);
 background-position: 100% 10%;
 }

.reference {
  margin:0 !important;
  color: #606d6e;
  padding: .5em !important;
height: 100px;
background: rgba(212, 212, 213, 0.2) !important;
border: none !important;
}
.reference img {
     width: 8.5em;
    filter: grayscale(1);
    -webkit-filter: grayscale(1);
    opacity: .65;
    margin: .8em;
}
.reference img:hover {
  opacity: 1;
}

  
  .common {
    padding: .5em !important;
    padding-top: 6em !important;
    padding-bottom: 6em !important;
    line-height: 2em;
    margin: auto;
    /*box-shadow: 0 4px 22px 0 rgba(0,0,0,0.1) !important; */
       
  }

 h2 {
 line-height: 1.1 !!important;
  word-spacing: .3em !important;
 color:#767676 !important;
}

  .footer {
    font-weight: 300;
        color: #F3F4F7;
        background: #122337;

    padding: 1.2em !important;
    text-align: center;
    bottom: 0;
    left: 0;
    right: 0;

    line-height: 24px;
    font-size: 1em;
  }

.footer span { color: #fff !important;}
 

  ul, ol {
    margin-left: auto;
    margin-right: auto;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    justify-content: flex-end;
    font-size: 1.2em !important;
    font-weight: 300;
    font-style: italic;
    color: #8b8b8b;
  }

  li {
    padding-right: 1em;
    width: 40%;
    }

  @media all and (min-width: 0) and (max-width: 480px) {
.intro img {
  width: 100% !important;
}
.why ul {
  width: 80% !important;
}
    ul {
      justify-content: flex-start;
    }
    li {
      width: 100%
    }
    
    .footer {
      position: relative !important;

    }
  }
  /*@media all and (min-width: 481px) and (max-width: 840px) {
                ul {
                    width: 52.8%;
                }
                li {
                    width: 80%;
                }

            }


            @media all and (min-width: 841px) and (max-width: 1280px) {
                ul {
                    width: 82%;
                }
                paper-button {
                    width: 30%;
                    margin: auto;
                }
                li {
                    width: 45%;
                    letter-spacing: .05em;
                }
            }



            @media all and (min-width: 1281px) and (max-width: 1600px) {
                ul {
                    width: 56.9%;
                }

            }*/
</style>



// WEBPACK FOOTER //
// Home.vue?5f14acde